

export const ProductDetailsViewLinkFactory = (productionStage = 'development') => {
    console.log(productionStage, "Product details view handler");
    if (productionStage === 'development') {
        return '/coreProductDetails';
    } else if (productionStage === 'catelogging') {
        return '/marketableProductDetails';

    }
}